import { render, staticRenderFns } from "./WordPressSlider.vue?vue&type=template&id=a01f15e4&"
import script from "./WordPressSlider.vue?vue&type=script&lang=js&"
export * from "./WordPressSlider.vue?vue&type=script&lang=js&"
import style0 from "./WordPressSlider.vue?vue&type=style&index=0&id=a01f15e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports